import React from "react";
import { Form, Formik } from "formik";
import { defaultFilter, ISearchProps } from "./type";
import { SearchAccordion } from "../../../common";
import { generateSearchFormItem } from "../../../../utils/helper";
import { useTranslation } from "react-i18next";

const Search = ({ filter, downloadData, setFilter }: ISearchProps) => {
  const { t } = useTranslation();

  return (
    <SearchAccordion>
      <Formik
        initialValues={filter}
        onSubmit={(values, { setSubmitting }) => {
          setFilter({ ...values, pages: 0 });
          setSubmitting(false);
        }}
      >
        {(form) => (
          <Form style={{ width: "100%" }}>
            {generateSearchFormItem(
              form,
              [
                {
                  type: "time",
                  name: "time",
                  label: "common.Time",
                },
                {
                  type: "text",
                  name: "UID",
                  label: "AccessRecord.UID",
                },
              ],
              defaultFilter(),
              t,
              downloadData,
              "Access Record"
            )}
          </Form>
        )}
      </Formik>
    </SearchAccordion>
  );
};

export default Search;
